import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { List, ListItem } from "@mui/material";

export default function ForList({ rows = 2, height = 80 }) {
  const _array = Array.from(Array(rows).keys());

  return (
    <div>
      {_array.map((elem) => (
        <List key={elem}>
          <ListItem>
            <Skeleton variant="rectangular" width="100%" height={height} />
          </ListItem>
        </List>
      ))}
    </div>
  );
}
